import { isObject } from "./model-utils";
import { Event } from "./event";
import { EventBundle } from "./event-bundle";
import { Ticket } from "./ticket";

export class EventTicket {
  [key: string]: any;
  constructor(json: any = {}) {
    Object.assign(this, json);
    const data = isObject(json.data) ? json.data : json;
    this.event = Event.fromJson(data.event);
    this.ticket = Ticket.fromJson(data.ticket || data);
  }

  static fromJson(json: any) {
    return isObject(json) ? new EventTicket(json) : json;
  }
}

export class EventTicketNo {
  [key: string]: any;
  constructor(json: any = {}) {
    Object.assign(this, json);
    this.ticket = Ticket.fromJson(json.ticket);
    this.ticketItem = EventBundle.fromJson(json.ticketItem);
  }

  static fromJson(json: any) {
    return isObject(json) ? new EventTicketNo(json) : json;
  }
}
